// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

// Factory for the active voice transport. Vapi is primary; set
// VITE_VOICE_TRANSPORT=livekit to swap once the LiveKit impl lands. This is the ONLY
// place that names a concrete transport — the controller and UI use VoiceTransport.

import type { VoiceTransport } from '../types'
import { VapiVoiceTransport } from './vapi-voice-transport'
import { LiveKitVoiceTransport } from './livekit-voice-transport'

export function createVoiceTransport(): VoiceTransport {
  const choice = (import.meta.env.VITE_VOICE_TRANSPORT ?? 'vapi').toLowerCase()
  if (choice === 'livekit') return new LiveKitVoiceTransport()
  return new VapiVoiceTransport()
}
